import set from 'lodash/set'
import { Map, List } from 'immutable'
import React, { Component } from 'react'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from 'actions'
import FormsyForm from 'formsy-react'
import PropTypes from 'prop-types'
import { TextInput } from 'components/FormInput.v2'
import SocialButton, { SOCIAL_BUTTON_TYPES, SOCIAL_BUTTON_SIZES } from 'components/SocialButton'
import { getShareV3Link, openWindow, SHARE_LINKS } from 'services/share'
import Sherpa, { TYPE_LARGE } from 'components/Sherpa'
import { SHARE_COMPLETED_GA4_EVENT } from 'services/event-tracking'
import { TYPE_CONTENT_VIDEO } from 'services/content-type'
import { getPrimary } from 'services/languages'
import { getPathLocationName } from 'services/url'

class ModalShare extends Component {
  //
  static getDerivedStateFromProps (props) {
    const { userRfd } = props
    // always update the shareLink
    // if nothing changed, it will not cause a re-render
    const shareLink = `${global.location.origin}${getShareV3Link(props)}`
    const nextState = { shareLink }

    if (userRfd) {
      set(nextState, 'view', 'share')
    }
    return nextState
  }

  constructor (props) {
    //
    super(props)
    // populate with initial state

    this.state = {
      view: 'loading',
      shareLink: '',
    }
  }

  componentDidMount () {
    const { props } = this
    const { getUserReferralData } = props
    getUserReferralData()
  }

  componentDidUpdate (_prevProps, prevState) {
    const { props } = this
    const { view, update } = props

    const { view: prevView } = prevState

    if (view !== prevView) {
      update()

      if (view === 'share') {
        this.sendGenerateLinkCTAEvent()
      }
    }
  }

  shareMedia (siteUrl) {
    return (e) => {
      e.preventDefault()
      const { state } = this
      const { shareLink } = state

      if (shareLink) {
        const shareUrl = encodeURIComponent(shareLink)
        const url = siteUrl.replace('{url}', shareUrl)
          .replace('{user_id}', SHARE_LINKS.GAIA_USER)
          .replace('{title}', this.props.title)

        openWindow(null, true, url)
      }
    }
  }

  sendGenerateLinkCTAEvent = () => {
    const { props } = this
    const {
      path,
      title,
      contentId,
      uiLocation,
      contentType,
      parentSeriesId,
      parentSeriesName,
      setDefaultGa4Event,
    } = props

    // GA4 event
    let ga4ShareCompletedEventData = SHARE_COMPLETED_GA4_EVENT.mergeDeep({
      content_id: contentId,
      content_name: title,
      content_type: contentType || TYPE_CONTENT_VIDEO,
      ui_location: uiLocation || getPathLocationName(path),
    })

    // Non series videos
    if (parentSeriesName) {
      ga4ShareCompletedEventData = ga4ShareCompletedEventData
        .mergeDeep({ parent_series_name: parentSeriesName })
    }

    if (parentSeriesId) {
      ga4ShareCompletedEventData = ga4ShareCompletedEventData
        .mergeDeep({ parent_series_id: parentSeriesId })
    }

    setDefaultGa4Event(ga4ShareCompletedEventData)
  }

  render () {
    const {
      props,
      state,
    } = this
    const {
      view, shareLink,
    } = state
    const {
      staticText,
    } = props

    if (view === 'loading') {
      return <Sherpa type={TYPE_LARGE} />
    }

    return (
      <FormsyForm
        className="modal-share__form"
        onSubmit={() => {}}
      >
        <div className="modal-share__description">
          {staticText.getIn(['data', 'shareUnlimited'])}
        </div>
        <div className="modal-share__input-wrapper">
          <TextInput
            label={staticText.getIn(['data', 'link'])}
            value={shareLink || ''}
            copyable={!!shareLink}
            autocomplete="off"
            name="link"
            readonly
            block
          />
        </div>
        <div className="modal-share__social">
          <ul className="modal-share__btns modal-share__btns__right">
            <li>
              <SocialButton
                size={SOCIAL_BUTTON_SIZES.LARGE}
                type={SOCIAL_BUTTON_TYPES.TWITTER}
                onClick={this.shareMedia(SHARE_LINKS.TWITTER)}
              />
            </li>
            <li>
              <SocialButton
                size={SOCIAL_BUTTON_SIZES.LARGE}
                type={SOCIAL_BUTTON_TYPES.FACEBOOK}
                onClick={this.shareMedia(SHARE_LINKS.FACEBOOK)}
              />
            </li>
            <li>
              <SocialButton
                size={SOCIAL_BUTTON_SIZES.LARGE}
                type={SOCIAL_BUTTON_TYPES.REDDIT}
                onClick={this.shareMedia(SHARE_LINKS.REDDIT)}
              />
            </li>
          </ul>
        </div>
      </FormsyForm>
    )
  }
}

ModalShare.propTypes = {
  contentUrl: PropTypes.string.isRequired,
  contentId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  parentSeriesId: PropTypes.number,
  parentSeriesName: PropTypes.string,
  uiLocation: PropTypes.string,
}

ModalShare.defaultProps = {
  contentType: TYPE_CONTENT_VIDEO,
}

export default connectRedux(
  (state) => ({
    userRfd: state.userReferrals.getIn(['data', 'referralId'], ''),
    staticText: state.staticText.getIn(['data', 'share'], Map()),
    userLang: getPrimary(state.user.getIn(['data', 'language'], List())),
    userUid: state.user.getIn(['data', 'uuid']),
    userAffId: state.ambassadors.getIn(['data', 'everflowAffiliateId']),
    path: state.resolver.get('path'),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      getUserReferralData: actions.userReferrals.getUserReferralData,
      setShareSource: actions.share.setShareSource,
      dismissModal: actions.dialog.dismissModal,
      setDefaultGa4Event: actions.eventTracking.setDefaultGa4Event,
    }
  },
)(ModalShare)
